const menu_array = []
menu_array_list.forEach((menu) => {
    if(menu?.sub_items){
        const items = []
        let pre = []
        menu?.sub_items?.forEach((item) => {
            if(item?.title?.includes?.(":new_li")){
                if(pre.length > 0){
                    items.push(pre)
                }
                pre = []
                const title = item?.title?.replace(" :new_li", "").replace(":new_li", "")
                pre.push({...item, title: title})
            }else {
                pre.push({...item})
            }
        })
        if(pre.length > 0){
            items.push(pre)
        }
        menu_array.push({...menu, sub_items: items})
    }
})

function randomStr(len = 10, arr = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ") {
    let ans = '';
    for (let i = len; i > 0; i--) {
        ans += arr[(Math.floor(Math.random() * arr.length))];
    }
    return ans
}

var img_list = []
var $img_li;
var prevId = false
const showImage = (id, imgId) => {
    if(img_list[id] && prevId != id){
        prevId = id
        const $div = $(`<div class="for-engage"><div id="img-view-${id}"><img src="${img_list[id]}" /></div><div>`)
        $("#"+imgId).html($div)
    }
}

$(document).ready(function() {
    
    const append_data = (selector) => {
        menu_array.forEach((item) => {
        

            const $li = document.querySelector(selector+item?.id)
            if($li){
                var imgShwon = false;
                
                if(item?.sub_items){
                    const $list = document.createElement(`ul`)
                    $list.classList.add("sub-menu", "thb-full-menu-new");
                    $li.appendChild($list)
            
                    const $li_array = []
                    Array.from({ length: Math.ceil(item?.sub_items.length / 2) }).forEach((_, index) => {
                        const $li = document.createElement("li")
                        $li.classList.add("column-group", "group-column_"+(index+1), "ui-menu-item")
                        $list.appendChild($li)
                        $li_array.push($li)
                    });
            
                    let imgId;
                    if(selector !== "."){
                        $img_li = document.createElement(`span`)
                        $img_li.classList.add("column-group", "group-column_last", "static-block", "image_view_column", "image_view_hover", "ui-menu-divider", "ui-widget-content")
                        imgID = randomStr()
                        $img_li.setAttribute("id", imgID)
                        $list.appendChild($img_li)
                    }
            
                    let index = -1;
                    item?.sub_items?.forEach((sub_item, idx) => {
                        if(idx % 2 == 0){
                            index++
                        } 
                        const $li = $li_array[index]
                        
                        const $ul = document.createElement("ul")
                        $ul.classList.add("column-group-content", "ui-menu", "ui-widget", "ui-widget-content")
                        $li.appendChild($ul)
            
                        sub_item?.forEach((item) => {
                            let title = item?.title
                            const replace = (r) => {
                                let exist = title?.includes(r)
                                title = title?.replace(" "+r, "").replace(r, "")
                                return exist;
                            }
            
                            let img_url;
                            if(title?.includes(":img_url")){
                                let regex = /:img_url:(https:\/\/[^\s]+)/;
                                const img_url_l = title.match(regex)?.[1];
                                title = title.replace(regex, '');
                                if(imgId){
                                    const ranodomID = randomStr()
                                    img_url = {id: ranodomID, url: img_url_l}
                                    img_list[ranodomID] = img_url_l
                                    if(!imgShwon){
                                        showImage(ranodomID, imgID)
                                        imgShwon = true
                                    }
                                }
                            }
            
                            const is_title = replace(":title")
                            const is_view_all = replace(":view_all")
            
                            let titel_el = title
            
                            if(replace(":colorful")){
                                const colors = ["#035d37", "#ee671d", "#0a0d81", "#b00024", "#035d37", "#ee671d", "#0a0d81", "#b00024", "#035d37", "#ee671d", "#b00024", "#035d37", "#ee671d", "#0a0d81", "#b00024", "#0a0d81"];
                                const len = colors.length
                                new_title = ""
                                title.split("").forEach((c, idx) => {
                                    if(idx > len){
                                        idx = 0
                                    }
                                    new_title += `<span style="color:${colors[idx]}">${c}</span>`
                                    idx++
                                })
                                titel_el = new_title
                            }
            
                            let $item = ""
                            if(is_title && item?.url == "/title"){
                                $item = `<li class="level1 menuitem--parent column_1 hide-on-mobile ui-menu-item">   
                                    <span class="wrapper-span parent_menu main ui-menu-item-wrapper">
                                        <span>${titel_el}</span>
                                    </span>
                                </li>`
                            }else {
                                $item = `<li ${img_url?.id && imgId ? `data-imgid="${img_url?.id}" data-img-wrapper-id="${imgID}"` : ""} class="${is_title ? "level1" : "level2"} ${img_url?.id ? "has_image_preview" : ""} ${is_view_all ? "title-view" : ""} hide-on-desktop ui-menu-item">   
                                    <a href="${item?.url}" class="main ui-menu-item-wrapper" title="${title}" tabindex="-1" role="menuitem">
                                        <span>
                                            ${titel_el} 
                                        </span>
                                    </a> 
                                </li>`
                            }
                            $ul.innerHTML += $item
                        })
            
                    })
                }
            }
        })
    }

    append_data(`#`)
    append_data(`.`)

    const activate = (index) => {
        $('.thb-full-menu-new-wrapper[data-index="'+index+'"]').addClass("active-part").siblings().removeClass("active-part")
    }
        
    const $activePart = $('.thb-full-menu-new-wrapper.active-part')
    if($activePart.length == 0){
        const $activeItem = $(".menu-item-has-children.active")
        if($activeItem){
            $('.thb-full-menu-new-wrapper[data-index="'+$activeItem.attr("data-index")+'"]').addClass("active-part default-active").siblings().removeClass("active-part")
        }
    }

    $("body").on("mouseover", ".menu-item-has-children", function(e) {
        let $e = $(e.target)
        if(!$e.hasClass("menu-item-has-children")){
            $e = $e.closest(".menu-item-has-children")
        }
        const id = $e.attr("data-index")
        activate(id)
    })
    $("body").on("mouseover", function(e) {
        if($(e.target).closest("theme-header").length == 0){
            $('.thb-full-menu-new-wrapper.default-active').addClass("active-part").siblings().removeClass("active-part")
        }
    })

    $(document).on("mouseover", ".has_image_preview", function(e) {
        let $e = $(e.target)
        if(!$e.hasClass("has_image_preview")){
            $e = $e.closest("li.has_image_preview")
        }
        const id = $e.attr("data-imgid")
        const dataid = $e.attr("data-img-wrapper-id")
        showImage(id, dataid)
    })
})